import api from './api';

export interface Diretoria {
  id: string;
  nome: string;
  sigla?: string;
  usuarioId?: string;
  descricao?: string;
  usuarioSubstitutoId?: string;
  dataFinal?: Date;
  dataInicial?: Date;
}

export const getAllDiretorias = () => api.get<Diretoria[]>('diretorias');
export const createDiretoria = (Diretoria: Diretoria) => {
  return api.post<any>('Diretorias', Diretoria)
};
export const updateDiretoria = (Diretoria: Diretoria) => api.put<any>(`diretorias/${Diretoria.id}`, Diretoria);
export const deleteDiretoria = (id: string) => api.delete(`diretorias/${id}`);

export const getAllDiretoriasOptions = () => getAllDiretorias().then(diretoria => (diretoria || []).map(a => ({ text: a.nome, value: a.id.toString() })))

